module.exports = __webpack_public_path__ + "img/cm.be118b83.png";